$(document).ready(function() {
	//Should be in document.ready and should be load after jquery datepicker files load.
	
	$.datepicker.setDefaults($.datepicker.regional[Globals.locale]);

});